module.exports = __webpack_public_path__ + "img/State=2.297d5b81.svg";